import { render, staticRenderFns } from "./ContactCreateForm.vue?vue&type=template&id=4e965b78&"
import script from "./ContactCreateForm.vue?vue&type=script&lang=js&"
export * from "./ContactCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports